import { render, staticRenderFns } from "./WordImportPage.vue?vue&type=template&id=dbf8061e&scoped=true&"
import script from "./WordImportPage.vue?vue&type=script&lang=js&"
export * from "./WordImportPage.vue?vue&type=script&lang=js&"
import style0 from "./WordImportPage.vue?vue&type=style&index=0&id=dbf8061e&prod&lang=scss&scoped=true&"
import style1 from "./WordImportPage.vue?vue&type=style&index=1&id=dbf8061e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf8061e",
  null
  
)

export default component.exports